export default __webpack_public_path__ + "static/pop-4ac14c7070bc01e5032d52feb93d4a91.mp3";